import {BsFillLightningFill, BsFillBarChartFill,BsBellFill,BsFillCaretDownFill} from 'react-icons/bs'
import {FaUserAlt} from 'react-icons/fa'
import {MdSpaceDashboard} from 'react-icons/md'
import {AiTwotoneSetting} from 'react-icons/ai'
import {FiMenu,FiSearch} from 'react-icons/fi'
import {GoLocation} from 'react-icons/go'

export default {
    user : FaUserAlt,
    dashboard: MdSpaceDashboard,
    settings: AiTwotoneSetting,
    menu: FiMenu,
    search: FiSearch,
    bell: BsBellFill,
    arrowDown: BsFillCaretDownFill,
    chart: BsFillBarChartFill,
    lightning: BsFillLightningFill,
    location: GoLocation
} 


